<template>
  <div>
    用户资料
  </div>
</template>

<script>
export default {
  name: 'DdtMallCoupons',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>